import { NavItem, LinkNavItem, ButtonNavItem, SubMenuNavItem } from "./types";

export function isLinkNavItem(item: NavItem): item is LinkNavItem {
  return "href" in item;
}

export function isButtonNavItem(item: NavItem): item is ButtonNavItem {
  return "onClick" in item;
}

export function isSubMenuNavItem(item: NavItem): item is SubMenuNavItem {
  return "children" in item;
}

export function filterVisibleItems(items: NavItem[]): NavItem[] {
  return items.filter(item => item.visible);
}

export function hasVisibleChildren(item: SubMenuNavItem): boolean {
  return item.children.some(child => child.visible);
}